(function MediaHubMediaSectionForm($, Adzuki)
{
	const component = {
		emits : ['close-sidebar', 'cancel'],
		inject: ['openToast'],
		props : {
			mediaSection: {
				type   : Object,
				default: {}
			},
		},
		template: '#mediasection-form',
		data() {
			return {
				sectionForm: {
					id           : null,
					name         : '',
					application  : '',
					internalName : '',
					sectionPath  : '',
					resizeWidth  : null,
					resizeHeight : null,
					allowedTypes : [],
					uploadLimit  : null,
					needsApproval: 0,
					// media_sections.is_attachment (MEDIA-268), switched here (MEDIA-296)
					isAttachment : false
				},
				adzukiApps: [],
				errors    : {},
				saving    : false,
			};
		},
		computed: {},
		methods : {
			validateForm() {
				this.errors = {};

				// Validate required fields
				if (!this.sectionForm.name || this.sectionForm.name.trim() === '') {
					this.errors.name = 'Name is required';
				}

				if (!this.sectionForm.internalName || this.sectionForm.internalName.trim() === '') {
					this.errors.internalName = 'Internal Name is required';
				}

				if (!this.sectionForm.application || this.sectionForm.application.trim() === '') {
					this.errors.application = 'Application is required';
				}

				if (!this.sectionForm.sectionPath || this.sectionForm.sectionPath.trim() === '') {
					this.errors.sectionPath = 'Section Path is required';
				}

				return Object.keys(this.errors).length === 0;
			},
			saveSection() {
				this.errors = {};

				if (!this.validateForm()) {
					// Show a general error message
					this.openToast('error', 'Please fill in all required fields');
					return;
				}

				const formData = new FormData();

				if (this.sectionForm.id) {
					formData.append('id', this.sectionForm.id);
				}


				formData.append('name', this.sectionForm.name);
				formData.append('internal_name', this.sectionForm.internalName);
				formData.append('application', this.sectionForm.application);
				formData.append('section_path', this.sectionForm.sectionPath);
				formData.append('return_url', this.sectionForm.returnUrl || '');
				formData.append('resize_width', this.sectionForm.resizeWidth || '');
				formData.append('resize_height', this.sectionForm.resizeHeight || '');
				formData.append('upload_limit', this.sectionForm.uploadLimit);
				formData.append('needs_approval', this.sectionForm.needsApproval ? 1 : 0);
				formData.append('is_attachment', this.sectionForm.isAttachment ? 1 : 0);

				formData.append('allowed_types', this.sectionForm.allowedTypes.sort().join( ',' ));

				this.saving = true;

				fetch(this.$baseUri + '/MediaSection/manageSection/', {
					method: 'POST',
					body  : formData,
				})
					.then(response => response.json())
					.then(data => {
						this.saving = false;

						if (data && data.error) {
							this.openToast('error', 'Error saving Media Section: ' + data.error);
							return;
						}

						if (this.sectionForm.id) {
							this.openToast('success', 'Media Section '+ this.sectionForm.name +' has been updated!');
						} else {
							this.openToast('success', 'Media Section' + data.name + ' saved!');
						}
						this.sectionForm = {};
						this.$emit('close-sidebar');
					})
					.catch(error => {
						this.saving = false;
						console.error('Error:', error);
						this.openToast('error', 'Error saving Media Section: ' + error);
					});

			},
			initializeForm() {
				if (Object.keys(this.mediaSection).length > 0) {
					this.sectionForm = {
						id           : this.mediaSection.id || null,
						name         : this.mediaSection.name || '',
						internalName : this.mediaSection.internal_name || '',
						application  : this.mediaSection.application || '',
						returnUrl    : this.mediaSection.return_url || '',
						sectionPath  : this.mediaSection.section_path || '',
						resizeWidth  : this.mediaSection.resize_width || null,
						resizeHeight : this.mediaSection.resize_height || null,
						uploadLimit  : this.mediaSection.upload_limit || null,
						needsApproval: String(this.mediaSection.needs_approval) === '1',
						isAttachment : String(this.mediaSection.is_attachment) === '1',
						allowedTypes : this.mediaSection.allowed_types ? this.mediaSection.allowed_types.split(',') : []
					};
				} else {
					const ogData = this.$options.data();
					this.sectionForm = ogData['sectionForm'];
				}
			},
			getAdzukiApps() {
				const url = `${this.$baseUri}/MediaSection/getAdzukiApps`;

				fetch(url)
					.then(response => {
						if (!response.ok) {
							throw new Error(`Error Fetching Applications: ${response.statusText}`);
						}
						return response.json();
					})
					.then(data => {
						this.adzukiApps = data;
					})
					.catch(error => {
						console.error('Error fetching Media Sections:', error);
					});
			},
			clearError(field) {
				if (this.errors[field]) {
					delete this.errors[field];
				}
			}
		},
		watch: {
			mediaSection: {
				handler(newVal) {
					this.initializeForm();
				},
				deep: true
			}
		},
		mounted() {
			this.getAdzukiApps();
			this.initializeForm();
		}
	};

	Adzuki.VueComponents.MediaHubMediaSectionForm = component;
}(jQuery, window.Adzuki || {}));